module.exports = __webpack_public_path__ + "img/icn_trash.e0ea0f4c.svg";